<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [formGroup]="formStep"
  >
  @if (showStep) {
    <app-audio-video-check (continueButtonClicked)="goToNextStep()"></app-audio-video-check>
  }
</app-wizard-step-wrapper>
